const Purple = {
  Purple: {
    _500: '#A855F7',
  },
};

export default Purple;
